<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <transition name="title">
          <div v-if="page === 0" key="update" class="title">{{ name }}</div>
          <div v-if="page === 1" key="info" class="title">Informações</div>
          <div v-if="page === 2" key="company" class="title">Permissões</div>
          <div v-if="page === 3" key="remove" class="title">Excluir Usuário</div>
        </transition>
        <div @click="$router.push('/usuario')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <transition name="page">
        <!-- Ações -->
        <div v-if="page === 0" key="page-0">
          <form @submit.prevent class="form">
            <button type="button" @click="page = 1" class="button-form"><i class="fas fa-info-circle"></i><span>Informações</span></button>
            <button type="button" @click="page = 2" class="button-form"><i class="fas fa-address-card"></i><span>Permissões</span></button>
            <button type="button" v-if="userId !== user.id" @click="page = 3" class="button-form"><i class="fas fa-trash-alt"></i><span>Excluir Usuário</span></button>
          </form>
        </div>
        <!-- Informações -->
        <div v-if="page === 1" key="page-1">
          <form @submit.prevent class="form">
            <!-- Nome -->
            <label>Nome</label>
            <input v-model="name" type="text" placeholder="Nome do usuário" :class="{ error : error.indexOf('name') > -1 }" />
            <div v-if="error.indexOf('name') > -1" class="hint">você esqueceu de digitar o nome</div>
            <!-- E-mail -->
            <label>E-mail</label>
            <input v-model="email" type="text" placeholder="E-mail para login" :class="{ error : error.indexOf('login') > -1 || error.indexOf('login-exists') > -1 }" />
            <div v-if="error.indexOf('login') > -1" class="hint">você esqueceu de digitar o e-mail</div>
            <div v-if="error.indexOf('login-exists') > -1" class="hint">Já existe um usuário com este e-mail</div>
            <!-- Senha -->
            <label>{{ id === 'new' ? 'Senha' : 'Alterar Senha' }}</label>
            <input v-model="password" type="password" :placeholder="id === 'new' ? 'Senha para login' : 'Nova senha'" :class="{ error : error.indexOf('password') > -1 }" />
            <div v-if="error.indexOf('password') > -1" class="hint">Senha inválida! No minímo 6 caracters</div>
            <!-- Repita a senha -->
            <label>Repita a senha</label>
            <input v-model="password2" type="password" :placeholder="id === 'new' ? 'Repita a senha' : 'Repita a nova senha'" :class="{ error : error.indexOf('password2') > -1 }" />
            <div v-if="error.indexOf('password2') > -1" class="hint">Repita a senha corretamente</div>
          </form>
          <div class="actions">
            <button v-if="id === 'new'" @click="changePage(0)" class="button-previous" style="visibility: hidden"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button v-if="id === 'new'" @click="changePage(2)" class="button-next"><span>Continuar</span><i class="fas fa-angle-right"></i></button>
            <button v-if="id !== 'new'" @click="changePage(0)" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button v-if="id !== 'new'" @click="update" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Atualizar</span></button>
          </div>
        </div>
        <!-- Permissões -->
        <div v-if="page === 2" key="page-2">
          <form @submit.prevent class="form">
            <!-- Dashboard -->
            <label class="switch">
              <input v-model="profileDashboard" type="checkbox">
              <span class="slider"></span>
              <span class="text">Dashboard</span>
            </label>
            <!-- Vitrine -->
            <label class="switch">
              <input v-model="profileShowcase" type="checkbox">
              <span class="slider"></span>
              <span class="text">Vitrine</span>
            </label>
            <label class="switch">
              <input v-model="profileSellOnlyReserved" type="checkbox">
              <span class="slider"></span>
              <span class="text">Venda apenas reservado</span>
            </label>
            <!-- Eventos -->
            <label class="switch">
              <input v-model="profileShow" type="checkbox">
              <span class="slider"></span>
              <span class="text">Eventos</span>
            </label>
            <!-- Bilheteria -->
            <label class="switch">
              <input v-model="profileTicket" type="checkbox">
              <span class="slider"></span>
              <span class="text">Bilheteria</span>
            </label>
            <!-- Validador -->
            <label class="switch">
              <input v-model="profileValidator" type="checkbox">
              <span class="slider"></span>
              <span class="text">Validador</span>
            </label>
            <!-- Borderôs -->
            <label class="switch">
              <input v-model="profileBordero" type="checkbox">
              <span class="slider"></span>
              <span class="text">Borderôs</span>
            </label>
            <!-- Vendas -->
            <label class="switch">
              <input v-model="profileTicketSale" type="checkbox">
              <span class="slider"></span>
              <span class="text">Vendas</span>
            </label>
            <!-- Tipos de Ingresso -->
            <label class="switch">
              <input v-model="profileTicketType" type="checkbox">
              <span class="slider"></span>
              <span class="text">Tipos de Ingresso</span>
            </label>
            <!-- Reservas -->
            <label class="switch">
              <input v-model="profileTicketBook" type="checkbox">
              <span class="slider"></span>
              <span class="text">Reservas</span>
            </label>
            <!-- Usuários -->
            <label v-if="userId !== user.id" class="switch">
              <input v-model="profileUser" type="checkbox">
              <span class="slider"></span >
              <span class="text">Usuários</span>
            </label>
            <!-- Configurações -->
            <label class="switch">
              <input v-model="profileSettings" type="checkbox">
              <span class="slider"></span>
              <span class="text">Configurações</span>
            </label>
            <!-- Informações -->
            <label class="switch">
              <input v-model="profileInfo" type="checkbox">
              <span class="slider"></span>
              <span class="text">Informações</span>
            </label>
            <!-- Financeiro -->
            <label class="switch">
              <input v-model="financial" type="checkbox">
              <span class="slider"></span>
              <span class="text">Financeiro</span>
            </label>
            <!-- Convites -->
            <label class="switch">
              <input v-model="invitation" type="checkbox">
              <span class="slider"></span>
              <span class="text">Convites</span>
            </label>
          </form>
          <div class="actions">
            <button v-if="id === 'new'" @click="changePage(1)" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button v-if="id === 'new'" @click="create" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Finalizar</span></button>
            <button v-if="id !== 'new'" @click="changePage(0)" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button v-if="id !== 'new'" @click="update" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Atualizar</span></button>
          </div>
        </div>
        <!-- Remover -->
        <div v-if="page === 3" key="page-3">
          <form @submit.prevent class="form">
            <label>Confirma exclusão do usuário {{ name }}?</label>
          </form>
          <div class="actions">
            <button v-if="id !== 'new'" @click="changePage(0)" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button v-if="id !== 'new'" @click="remove" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { get, create, update, remove } from '../api/businessUser'

export default {
  name: 'user',
  props: ['id'],
  data () {
    return {
      loading: false,
      page: null,
      error: [],
      name: null,
      email: null,
      password: null,
      password2: null,
      profileShowcase: false,
      profileSellOnlyReserved: false,
      profileDashboard: false,
      profileBordero: false,
      profileShow: false,
      profileTicket: false,
      profileValidator: false,
      profileTicketSale: false,
      profileTicketType: false,
      profileTicketBook: false,
      profileUser: false,
      profileSettings: false,
      profileInfo: false,
      financial: false,
      invitation: false,
      userId: null
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async mounted () {
    // Create
    if (this.id === 'new') {
      this.page = 1
    // Update
    } else {
      const user = await get(this.id)
      this.name = user.name
      this.email = user.login
      this.profileShowcase = user.profile.includes('showcase')
      this.profileSellOnlyReserved = user.profile.includes('sellOnlyReserved')
      this.profileDashboard = user.profile.includes('dashboard')
      this.profileBordero = user.profile.includes('bordero')
      this.profileShow = user.profile.includes('show')
      this.profileTicket = user.profile.includes('ticket')
      this.profileValidator = user.profile.includes('validator')
      this.profileTicketSale = user.profile.includes('ticket-sale')
      this.profileTicketType = user.profile.includes('ticket-type')
      this.profileTicketBook = user.profile.includes('ticket-book')
      this.profileUser = user.profile.includes('user')
      this.profileSettings = user.profile.includes('settings')
      this.financial = user.profile.includes('financial')
      this.profileInfo = user.profile.includes('info')
      this.invitation = user.profile.includes('invitation')
      this.userId = user.userId
      this.page = 0
    }
  },
  methods: {
    changePage (page) {
      if (this.loading) return false
      this.page = page
    },
    async create () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        // Profile
        const profile = []
        if (this.profileShowcase) profile.push('showcase')
        if (this.profileSellOnlyReserved) profile.push('sellOnlyReserved')
        if (this.profileDashboard) profile.push('dashboard')
        if (this.profileBordero) profile.push('bordero')
        if (this.profileShow) profile.push('show')
        if (this.profileTicket) profile.push('ticket')
        if (this.profileValidator) profile.push('validator')
        if (this.profileTicketSale) profile.push('ticket-sale')
        if (this.profileTicketType) profile.push('ticket-type')
        if (this.profileTicketBook) profile.push('ticket-book')
        if (this.profileUser) profile.push('user')
        if (this.profileSettings) profile.push('settings')
        if (this.profileInfo) profile.push('info')
        if (this.financial) profile.push('financial')
        if (this.invitation) profile.push('invitation')
        // Create user
        await create(this.email, this.password, this.password2, this.name, profile)
        this.loading = false
        this.$router.push('/usuario')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          this.page = 1
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    },
    async update () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        // Profile
        const profile = []
        if (this.profileShowcase) profile.push('showcase')
        if (this.profileSellOnlyReserved) profile.push('sellOnlyReserved')
        if (this.profileDashboard) profile.push('dashboard')
        if (this.profileBordero) profile.push('bordero')
        if (this.profileShow) profile.push('show')
        if (this.profileTicket) profile.push('ticket')
        if (this.profileValidator) profile.push('validator')
        if (this.profileTicketSale) profile.push('ticket-sale')
        if (this.profileTicketType) profile.push('ticket-type')
        if (this.profileTicketBook) profile.push('ticket-book')
        if (this.profileUser) profile.push('user')
        if (this.profileSettings) profile.push('settings')
        if (this.financial) profile.push('financial')
        if (this.profileInfo) profile.push('info')
        if (this.invitation) profile.push('invitation')
        // Update user
        await update(this.id, this.email, this.password, this.password2, this.name, profile, this.userId)
        this.loading = false
        this.$router.push('/usuario')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          this.page = 1
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    },
    async remove () {
      try {
        if (this.loading) return false
        this.loading = true
        // Update user
        await remove(this.userId)
        this.loading = false
        this.$router.push('/usuario')
      } catch (error) {
        logger.error(error, this)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  .switch {
    margin: 5px 0;
  }
}
</style>
